import { Component, OnInit } from '@angular/core';
import {
  ColorDisplaycolumn,
  DataListFilterColumn,
  Datalistviewcolumn
} from 'src/app/shared/datalistview/columns/datalistviewcolumn';

@Component({
    selector: 'app-pricerules',
    templateUrl: './pricerules.component.html',
    styleUrls: ['./pricerules.component.scss'],
    standalone: false
})
export class PricerulesComponent implements OnInit {

  constructor() { }

  public Columns : Array<Datalistviewcolumn> = [
    new ColorDisplaycolumn("Color", "Color", "5em"),
    new DataListFilterColumn("Name", "Name", true, "Name"),
    new Datalistviewcolumn("Description", "Description"),
    new DataListFilterColumn("Type", "RateType", true, "RateType"),
  ];

  ngOnInit(): void {
  }

}
